export default "__VITE_ASSET__BQ5giwB7__";